import { activeStyles } from "./values.js"

/**
 * Determines whether to show or hide active indicator
 *
 * @param {bool} active active state
 * @param {string} style active style
 * @returns {bool}
 */
export const showIndicator = (style) => {
  return style === activeStyles.highlight ? false : true
}
